import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input"]

  connect() {
    this.inputTarget.addEventListener("input", this.validateInput.bind(this))
  }

  validateInput(event) {
    const input = event.target
    const sanitizedValue = input.value.replace(/[^0-9,.]/g, "")
    input.value = sanitizedValue
  }

  validateFirstCharacter() {
    const inputValue = this.inputTarget.value
    if (!/^\d/.test(inputValue)) {
      this.inputTarget.value = inputValue.replace(/^[^\d]+/, "")
    }
  }
}
